import { render, staticRenderFns } from "./userPhysicalInfo.vue?vue&type=template&id=7528fac8&scoped=true&"
import script from "./userPhysicalInfo.vue?vue&type=script&lang=js&"
export * from "./userPhysicalInfo.vue?vue&type=script&lang=js&"
import style0 from "./userPhysicalInfo.vue?vue&type=style&index=0&id=7528fac8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7528fac8",
  null
  
)

export default component.exports